export var useOnEnterHandler = function (handler) {
    return function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
            handler();
            e.preventDefault();
        }
    };
};
//# sourceMappingURL=onEnterHandlerHook.js.map